import {
    Box,
    Typography
} from '@mui/material';

import { ExpandableThumbnail } from './image/ExpandableThumbnail';
import { ImageEntity } from '../../lib/dashboard/types/ImageEntity';
import { Location } from "../../API";
import { useResolveImageEntity } from '../../lib/dashboard/hooks/useResolveImageEntity';

type LocationCardHeaderProps = {
    location: Location;
    images: ImageEntity[];
};

const LocationCardHeader = (props: LocationCardHeaderProps) => {
    const { location, images } = props;
    const { resolvedImageEntities } = useResolveImageEntity(images);

    return (
        <Box display="flex" flexDirection="row" gap={2} alignItems="center" p={{ xs: 1, md: 2 }}>
            <ExpandableThumbnail images={resolvedImageEntities} />
            <Box display="flex" flexDirection="column">
                <Typography fontSize="1.25rem" fontWeight={700}>
                    {location.name ?? `Unnamed location`}
                </Typography>
            </Box>
        </Box>
    );
};

export default LocationCardHeader;